import { schema } from 'normalizr';


 const contact = new schema.Entity('contacts',{},{ idAttribute : 'id_pessoa_pes'});
 export const contactSchema = new schema.Array(contact);


// WEBPACK FOOTER //
// ./src/redux/schemas.js